// Bilingual content dictionary for Nina Latinos Multi Services, LLC
export const translations = {
  en: {
    nav: {
      services: "Services",
      about: "About Ms. A Vidal",
      portal: "Document Portal",
      contact: "Contact Us",
      notice: "Notice",
      cta: "Get Started Now",
      langLabel: "Language",
    },
    hero: {
      eyebrow: "Family-Owned · Philadelphia · Bilingual (EN / ES)",
      headline: "Your Trusted Partner for Financial, Legal, and Community Solutions.",
      subheadline:
        "A proudly family-owned business offering professional Tax, Administrative, and Business Services in Philadelphia. Built on trust, delivered with excellence.",
      primaryCta: "Upload Documents / Contact Us",
      secondaryCta: "View Services",
      bullets: [
        "Secure document upload portal",
        "Bilingual support every step of the way",
        "Response within 24–48 business hours",
      ],
      badge: "Secure document handling",
      serving: "Proudly serving Philadelphia & surrounding communities",
      cardName: "Ms. A. Vidal",
      cardRole: "Owner & Founder",
    },
    services: {
      title: "Our Services",
      subtitle:
        "Everything you need — handled with care, clarity, and confidentiality.",
      flagshipBadge: "Most Requested",
      comingSoonBadge: "Coming Soon",
      waitlistCta: "Join the Waitlist",
      learnMore: "Request this service",
      items: [
        {
          key: "tax",
          icon: "ReceiptText",
          title: "Tax Preparation & Planning",
          desc: "Accurate personal and business tax preparation with year-round planning to protect what you've earned.",
          featured: true,
        },
        {
          key: "notary",
          icon: "Stamp",
          title: "Notary Public Services",
          desc: "Official notarization of documents you can trust, handled quickly and professionally.",
        },
        {
          key: "translation",
          icon: "Languages",
          title: "Bilingual Translation & Interpretation",
          desc: "Clear English–Spanish translation and live interpretation for documents and appointments.",
        },
        {
          key: "business",
          icon: "Building2",
          title: "Business Consulting & Formations",
          desc: "LLC formations, registrations, and consulting to launch and grow your business the right way.",
        },
        {
          key: "docprep",
          icon: "FileText",
          title: "Certified Document Preparation",
          desc: "Carefully prepared and reviewed documents, completed correctly the first time.",
        },
        {
          key: "immigration",
          icon: "Globe",
          title: "Immigration Form Assistance",
          desc: "Compassionate, detail-first assistance completing immigration forms and applications.",
        },
        {
          key: "admin",
          icon: "ClipboardList",
          title: "Full Administrative & Supportive Services",
          desc: "From paperwork to follow-ups, comprehensive administrative support tailored to you.",
        },
      ],
      comingSoon: {
        key: "autotags",
        icon: "Car",
        title: "Auto Tags & Money Transfer (Ria)",
        desc: "Auto Tags & Money Transfer Services (Ria) — Expanding soon to serve you better!",
      },
    },
    about: {
      eyebrow: "About the Founder",
      header: "Meet Ms. A Vidal",
      subheader: "Founder & Your Local Tax Professional",
      tabsEn: "English",
      tabsEs: "Español",
      languages: "Languages: English / Español",
      verified: "Verified · Community Trusted",
      motto: "“If I can't help you, no one can.”",
      paragraphs: [
        "Ms. A Vidal is a committed entrepreneur, real estate professional, and community advocate with a deep calling to serve. As the owner and founder of Nina Latinos Multi Services LLC and Nina Latinos Auto Tags y Mas Corp, she offers a wide range of services including business formation assistance, tax preparation, notary services, translations, immigration support, and vehicle registration and titling services.",
        "In addition to running her successful businesses, Ms. A Vidal is a licensed real estate agent working with Homestarr Inc., helping individuals and families achieve their goals of homeownership. Her extensive professional background also includes more than 15 years of service as a state employee, where she developed strong skills in customer service, problem-solving, and public assistance.",
        "As a proud mother of six beautiful children, Ms. A Vidal understands the importance of hard work, perseverance, and dedication. She has devoted her career to serving her community and helping people from all walks of life. Her commitment to others goes beyond her professional responsibilities, as she continually strives to provide guidance, support, and solutions to those in need.",
        "Ms. A Vidal is known for her compassionate approach, strong work ethic, and determination to find answers and resources for her clients. Through her businesses and professional projects, she continues to make a positive impact on her community by empowering individuals, supporting families, and helping people make important personal, financial, and business decisions.",
      ],
    },
    portal: {
      eyebrow: "Secure & Confidential",
      title: "Secure Document Upload & Contact",
      subtitle:
        "Send your documents and tell us how we can help. We'll get back to you quickly.",
      uploadTitle: "Securely Send Us Your Documents",
      uploadSubtext:
        "Drag and drop your tax documents, ID, or administrative forms here to speed up your processing.",
      uploadCta: "Browse files",
      uploadDrop: "Drop files to upload",
      uploadAriaLabel: "Upload your documents — PDF, JPG, PNG or Word",
      uploadConstraints: "Accepted: PDF, JPG, PNG, DOC, DOCX · Max 15MB each",
      uploadSecure: "Your files are encrypted in transit and stored securely.",
      filesSelected: "Selected files",
      removeFile: "Remove",
      formTitle: "Tell us what you need",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email Address",
      message: "Your Request",
      messageHelp:
        "Briefly tell us what issue you are experiencing or what service you require (Max 500 characters).",
      charCount: "characters",
      submit: "Submit Request",
      submitting: "Submitting…",
      slaBanner: "We will contact you back within 24–48 business hours.",
      successTitle: "Thank you! Your request has been received.",
      successBody:
        "Our team will contact you within 24–48 business hours. A copy of your details is securely on file.",
      sendAnother: "Send another request",
      errName: "Please enter your full name.",
      errPhone: "Please enter a valid phone number.",
      errEmail: "Please enter a valid email address.",
      errMessage: "Please describe your request.",
      uploadError: "Some files could not be uploaded",
      leadError: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "Trust. Excellence. Community.",
      about:
        "Professional tax, administrative, legal, and business services for Philadelphia's Latino community and beyond.",
      seHablaEspanol: "Se habla español",
      locationTitle: "Visit Us",
      address: "1639 E Cheltenham Ave, Philadelphia, PA 19124",
      getDirections: "Get directions",
      contactTitle: "Contact",
      office: "Office",
      fax: "Fax",
      emailLabel: "Email",
      hoursTitle: "Business Hours",
      quickLinks: "Quick Links",
      adminLink: "Admin Login",
      days: {
        monThu: "Monday – Thursday",
        fri: "Friday",
        sat: "Saturday",
        sun: "Sunday",
      },
      hoursValue: "9:00 AM – 6:00 PM",
      closed: "Closed",
      holidayNote: "Hours may differ on national holidays.",
      rights: "All rights reserved.",
    },
    admin: {
      loginTitle: "Admin Portal",
      loginSubtitle: "Sign in to view leads and uploaded documents.",
      password: "Password",
      signIn: "Sign In",
      signingIn: "Signing in…",
      wrongPassword: "Incorrect password. Please try again.",
      backToSite: "Back to website",
      dashboardTitle: "Dashboard",
      logout: "Log out",
      totalLeads: "Total Leads",
      totalDocs: "Total Documents",
      tabLeads: "Leads",
      tabDocs: "Documents",
      search: "Search leads…",
      colName: "Name",
      colContact: "Contact",
      colMessage: "Message",
      colDocs: "Docs",
      colDate: "Date",
      colFile: "File",
      colType: "Type",
      colSize: "Size",
      colLead: "Lead",
      download: "Download",
      noLeads: "No leads yet.",
      noDocs: "No documents yet.",
      viewDetails: "View",
      leadDetails: "Lead Details",
      close: "Close",
      colStatus: "Status",
      statusLabel: "Status",
      statusAll: "All statuses",
      statuses: {
        new: "New",
        contacted: "Contacted",
        in_progress: "In progress",
        closed: "Closed",
      },
      notesLabel: "Internal notes (private)",
      notesPlaceholder: "Only visible to you. E.g. called on Monday, waiting for W-2…",
      notesHint: "Never shown to the client.",
      save: "Save changes",
      saving: "Saving…",
      saved: "Lead updated",
      saveError: "Could not save changes",
      noStatusResults: "No leads match this filter.",
    },
  },

  es: {
    nav: {
      services: "Servicios",
      about: "Sobre Ms. A Vidal",
      portal: "Portal de Documentos",
      contact: "Contáctenos",
      notice: "Aviso",
      cta: "Comenzar Ahora",
      langLabel: "Idioma",
    },
    hero: {
      eyebrow: "Negocio Familiar · Filadelfia · Bilingüe (EN / ES)",
      headline: "Su Socio de Confianza para Soluciones Financieras, Legales y Comunitarias.",
      subheadline:
        "Un negocio con orgullo familiar que ofrece servicios profesionales de impuestos, administrativos y de negocios en Filadelfia. Basados en la confianza, brindados con excelencia.",
      primaryCta: "Subir Documentos / Contáctenos",
      secondaryCta: "Ver Servicios",
      bullets: [
        "Portal seguro para subir documentos",
        "Atención bilingüe en cada paso",
        "Respuesta en 24–48 horas laborables",
      ],
      badge: "Manejo seguro de documentos",
      serving: "Con orgullo al servicio de Filadelfia y comunidades cercanas",
      cardName: "Sra. A. Vidal",
      cardRole: "Propietaria y Fundadora",
    },
    services: {
      title: "Nuestros Servicios",
      subtitle:
        "Todo lo que necesita — con cuidado, claridad y confidencialidad.",
      flagshipBadge: "Más solicitado",
      comingSoonBadge: "Próximamente",
      waitlistCta: "Unirme a la Lista",
      learnMore: "Solicitar este servicio",
      items: [
        {
          key: "tax",
          icon: "ReceiptText",
          title: "Preparación y Planificación de Impuestos",
          desc: "Preparación precisa de impuestos personales y de negocios, con planificación durante todo el año para proteger lo que ha ganado.",
          featured: true,
        },
        {
          key: "notary",
          icon: "Stamp",
          title: "Servicios de Notaría Pública",
          desc: "Notarización oficial de documentos en la que puede confiar, realizada de forma rápida y profesional.",
        },
        {
          key: "translation",
          icon: "Languages",
          title: "Traducción e Interpretación Bilingüe",
          desc: "Traducción clara inglés–español e interpretación en vivo para documentos y citas.",
        },
        {
          key: "business",
          icon: "Building2",
          title: "Consultoría y Formación de Negocios",
          desc: "Formación de LLC, registros y consultoría para iniciar y hacer crecer su negocio de la manera correcta.",
        },
        {
          key: "docprep",
          icon: "FileText",
          title: "Preparación Certificada de Documentos",
          desc: "Documentos preparados y revisados cuidadosamente, completados correctamente desde la primera vez.",
        },
        {
          key: "immigration",
          icon: "Globe",
          title: "Asistencia con Formularios de Inmigración",
          desc: "Asistencia compasiva y detallista para completar formularios y solicitudes de inmigración.",
        },
        {
          key: "admin",
          icon: "ClipboardList",
          title: "Servicios Administrativos y de Apoyo Integral",
          desc: "Desde el papeleo hasta el seguimiento, apoyo administrativo integral adaptado a usted.",
        },
      ],
      comingSoon: {
        key: "autotags",
        icon: "Car",
        title: "Marbetes de Auto y Envío de Dinero (Ria)",
        desc: "Servicios de Marbetes de Auto y Envío de Dinero (Ria) — ¡Pronto ampliaremos para servirle mejor!",
      },
    },
    about: {
      eyebrow: "Sobre la Fundadora",
      header: "Conozca a Ms. A Vidal",
      subheader: "Fundadora y su Profesional de Impuestos Local",
      tabsEn: "English",
      tabsEs: "Español",
      languages: "Idiomas: English / Español",
      verified: "Verificada · De confianza para la comunidad",
      motto: "“Si yo no puedo ayudarte, nadie podrá.”",
      paragraphs: [
        "Ms. A Vidal es una empresaria comprometida, profesional del sector inmobiliario y defensora de la comunidad, con una gran vocación de servicio. Como propietaria y fundadora de Nina Latinos Multi Services LLC y Nina Latinos Auto Tags y Mas Corp, ofrece una amplia gama de servicios, que incluyen asistencia para la constitución de empresas, preparación de impuestos, servicios notariales, traducciones, apoyo en materia de inmigración y servicios de matriculación y registro de vehículos.",
        "Además de administrar sus exitosos negocios, Ms. A Vidal es agente inmobiliaria con licencia y trabaja con Homestarr Inc., ayudando a personas y familias a alcanzar sus metas de tener una vivienda propia. Su amplia trayectoria profesional también incluye más de 15 años de servicio como empleada estatal, donde desarrolló sólidas habilidades en atención al cliente, resolución de problemas y asistencia pública.",
        "Como orgullosa madre de seis hermosos hijos, Ms. A Vidal comprende la importancia del trabajo duro, la perseverancia y la dedicación. Ha dedicado su carrera a servir a su comunidad y ayudar a personas de todos los ámbitos de la vida. Su compromiso con los demás va más allá de sus responsabilidades profesionales, ya que se esfuerza continuamente por brindar orientación, apoyo y soluciones a quienes lo necesitan.",
        "Ms. A Vidal es conocida por su trato compasivo, su sólida ética de trabajo y su determinación para encontrar respuestas y recursos para sus clientes. A través de sus negocios y proyectos profesionales, Ms. A Vidal continúa teniendo un impacto positivo en su comunidad al empoderar a las personas, apoyar a las familias y ayudar a la gente a tomar decisiones importantes a nivel personal, financiero y empresarial.",
      ],
    },
    portal: {
      eyebrow: "Seguro y Confidencial",
      title: "Subida Segura de Documentos y Contacto",
      subtitle:
        "Envíe sus documentos y cuéntenos cómo podemos ayudarle. Le responderemos rápidamente.",
      uploadTitle: "Envíenos sus Documentos de Forma Segura",
      uploadSubtext:
        "Arrastre y suelte aquí sus documentos de impuestos, identificación o formularios administrativos para agilizar su trámite.",
      uploadCta: "Buscar archivos",
      uploadDrop: "Suelte los archivos para subir",
      uploadAriaLabel: "Sube tus documentos — PDF, JPG, PNG o Word",
      uploadConstraints: "Aceptamos: PDF, JPG, PNG, DOC, DOCX · Máx 15MB cada uno",
      uploadSecure: "Sus archivos se cifran en tránsito y se guardan de forma segura.",
      filesSelected: "Archivos seleccionados",
      removeFile: "Quitar",
      formTitle: "Cuéntenos qué necesita",
      name: "Nombre Completo",
      phone: "Número de Teléfono",
      email: "Correo Electrónico",
      message: "Su Solicitud",
      messageHelp:
        "Cuéntenos brevemente qué problema tiene o qué servicio necesita (Máx 500 caracteres).",
      charCount: "caracteres",
      submit: "Enviar Solicitud",
      submitting: "Enviando…",
      slaBanner: "Nos comunicaremos con usted dentro de 24–48 horas laborables.",
      successTitle: "¡Gracias! Hemos recibido su solicitud.",
      successBody:
        "Nuestro equipo se comunicará con usted dentro de 24–48 horas laborables. Una copia de sus datos está guardada de forma segura.",
      sendAnother: "Enviar otra solicitud",
      errName: "Por favor ingrese su nombre completo.",
      errPhone: "Por favor ingrese un número de teléfono válido.",
      errEmail: "Por favor ingrese un correo electrónico válido.",
      errMessage: "Por favor describa su solicitud.",
      uploadError: "Algunos archivos no se pudieron subir",
      leadError: "Algo salió mal. Por favor intente de nuevo.",
    },
    footer: {
      tagline: "Confianza. Excelencia. Comunidad.",
      about:
        "Servicios profesionales de impuestos, administrativos, legales y de negocios para la comunidad latina de Filadelfia y más allá.",
      seHablaEspanol: "Se habla español",
      locationTitle: "Visítenos",
      address: "1639 E Cheltenham Ave, Philadelphia, PA 19124",
      getDirections: "Cómo llegar",
      contactTitle: "Contacto",
      office: "Oficina",
      fax: "Fax",
      emailLabel: "Correo",
      hoursTitle: "Horario de Atención",
      quickLinks: "Enlaces Rápidos",
      adminLink: "Acceso de Administrador",
      days: {
        monThu: "Lunes – Jueves",
        fri: "Viernes",
        sat: "Sábado",
        sun: "Domingo",
      },
      hoursValue: "9:00 AM – 6:00 PM",
      closed: "Cerrado",
      holidayNote: "El horario puede variar en días feriados nacionales.",
      rights: "Todos los derechos reservados.",
    },
    admin: {
      loginTitle: "Portal de Administrador",
      loginSubtitle: "Inicie sesión para ver solicitudes y documentos subidos.",
      password: "Contraseña",
      signIn: "Iniciar Sesión",
      signingIn: "Iniciando…",
      wrongPassword: "Contraseña incorrecta. Intente de nuevo.",
      backToSite: "Volver al sitio web",
      dashboardTitle: "Panel de Control",
      logout: "Cerrar sesión",
      totalLeads: "Solicitudes Totales",
      totalDocs: "Documentos Totales",
      tabLeads: "Solicitudes",
      tabDocs: "Documentos",
      search: "Buscar solicitudes…",
      colName: "Nombre",
      colContact: "Contacto",
      colMessage: "Mensaje",
      colDocs: "Docs",
      colDate: "Fecha",
      colFile: "Archivo",
      colType: "Tipo",
      colSize: "Tamaño",
      colLead: "Solicitud",
      download: "Descargar",
      noLeads: "Aún no hay solicitudes.",
      noDocs: "Aún no hay documentos.",
      viewDetails: "Ver",
      leadDetails: "Detalles de la Solicitud",
      close: "Cerrar",
      colStatus: "Estado",
      statusLabel: "Estado",
      statusAll: "Todos los estados",
      statuses: {
        new: "Nuevo",
        contacted: "Contactado",
        in_progress: "En proceso",
        closed: "Cerrado",
      },
      notesLabel: "Notas internas (privadas)",
      notesPlaceholder: "Solo visibles para usted. Ej.: llamé el lunes, falta el W-2…",
      notesHint: "Nunca se muestran al cliente.",
      save: "Guardar cambios",
      saving: "Guardando…",
      saved: "Solicitud actualizada",
      saveError: "No se pudieron guardar los cambios",
      noStatusResults: "Ninguna solicitud coincide con este filtro.",
    },
  },
};

export default translations;
